import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component, cloneElement, createContext } from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import { noop } from 'Helpers/PropTypes';
import { withHousehold } from 'Context/HouseholdContext';
import withViewContext from './withViewContext';

const ContextIndex = createContext(-1);

export { ContextIndex };

class FieldList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDone: false,
      idList: [],
      newId: -1,
      removeId: -1,
    };

    this.getRemoveButton = this.getRemoveButton.bind(this);
    this.addClone = this.addClone.bind(this);
    this.removeIndex = this.removeIndex.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      keyPrefix,
      addElementOnLoad,
      fetchIndex,
    } = this.props;

    return fetchIndex(householdId, keyPrefix)
      .then((res) => {
        this.setState({ idList: res ? res.map(entry => entry.id) : [] }, () => {
          const { idList } = this.state;
          this.handleCountUpdate(idList.length);
          if (addElementOnLoad) {
            this.addClone();
          }
        });
      })
      .finally(() => this.setState({ isDone: true }));
  }

  getRemoveButton(index) {
    const { removeId } = this.state;
    const { removeIndex } = this;

    const button = (
      <a
        role="presentation"
        className="remove"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          this.setState({ removeId: index });
        }}
      >
        <FontAwesome icon="remove" />
        <span>Delete</span>
      </a>
    );

    const prompt = (
      <div className="remove">
        <span className="pad-right">Are you sure you want to delete this?</span>
        <a role="presentation" onClick={removeIndex(index)}>
          <span className="pad-right color-facet-green">Yes</span>
        </a>
        <a
          role="presentation"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({ removeId: -1 });
          }}
        >
          <span className="color-facet-red">No</span>
        </a>
      </div>
    );
    return (
      <span className="questionnaire-input">
        {removeId === index ? prompt : button}
      </span>
    );
  }

  handleCountUpdate(count) {
    const { onCountUpdate } = this.props;
    if (onCountUpdate !== null) onCountUpdate(count);
  }

  addClone() {
    const { createIndex, householdId, keyPrefix } = this.props;
    createIndex(householdId, keyPrefix).then(({ data: { id } }) => {
      const { idList } = this.state;
      idList.push(id);
      this.handleCountUpdate(idList.length);
      this.setState({ idList, newId: id });
    });
  }

  removeIndex(index) {
    const {
      householdId, keyPrefix, removeIndex, onRemove,
    } = this.props;
    return (e) => {
      e.preventDefault();
      e.stopPropagation();
      removeIndex(householdId, keyPrefix, index).then(({ data: { id } }) => {
        let { idList } = this.state;
        idList = idList.filter(inList => inList !== id);
        this.handleCountUpdate(idList.length);
        this.setState({ idList });
        onRemove(id);
      });
    };
  }

  render() {
    const {
      getRemoveButton,
      props: {
        label, addLabel, keyPrefix, Of, childProps,
      },
      state: { idList, newId, isDone },
    } = this;

    if (!isDone) {
      return null;
    }

    const clones = [];
    for (let x = 0; x < idList.length; x += 1) {
      const id = idList[x];
      const isNew = id === newId;
      const clone = cloneElement(
        <Of {...childProps} expanded={isNew} id={id}>
          {getRemoveButton(id)}
        </Of>,
        {
          key: `${keyPrefix}-${id}`,
        },
      );
      clones.push(
        <ContextIndex.Provider key={`provider-${keyPrefix}-${id}`} value={id}>
          {clone}
        </ContextIndex.Provider>,
      );
    }

    return (
      <div className="questionnaire-field-list">
        {label !== '' && (
          <div className="questionnaire-field-list-header">
            <span className="field-list-label">{label}</span>
          </div>
        )}
        {clones && clones.length > 0 && (
          <div className="questionnaire-field-list-clones">{clones}</div>
        )}
        <div className="questionnaire-field-list-footer">
          <span
            role="presentation"
            onClick={this.addClone}
            className="field-list-add-label"
          >
            <FontAwesome icon="plus-circle" />
            <button type="button" test={label}>
              <span>{addLabel}</span>
            </button>
          </span>
        </div>
      </div>
    );
  }
}

FieldList.propTypes = {
  createIndex: PropTypes.func.isRequired,
  fetchIndex: PropTypes.instanceOf(Object).isRequired,
  removeIndex: PropTypes.func.isRequired,
  householdId: PropTypes.number.isRequired,
  label: PropTypes.string,
  addLabel: PropTypes.string,
  keyPrefix: PropTypes.string.isRequired,
  Of: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(Component)])
    .isRequired,
  childProps: PropTypes.instanceOf(Object),
  addElementOnLoad: PropTypes.bool,
  onRemove: PropTypes.func,
  onCountUpdate: PropTypes.func,
};

FieldList.defaultProps = {
  label: '',
  addLabel: '',
  childProps: {},
  addElementOnLoad: false,
  onRemove: noop,
  onCountUpdate: null,
};

export default withHousehold(withQuestionnaireFuncs(withViewContext(FieldList)));
